import { store } from "../stores/store";

let pollTimer = null;

let appInstance;

export const VersionService = {
  setApp(app) {
    appInstance = app;
  },
  get toast() {
    return appInstance?.config?.globalProperties?.$toast;
  },
  startPolling(intervalMs = 5 * 60 * 1000) {
    if (typeof window === "undefined" || typeof fetch === "undefined") {
      return;
    }

    const check = () => {
      this.checkForUpdate();
    };

    check();

    if (pollTimer) {
      clearInterval(pollTimer);
    }
    pollTimer = window.setInterval(check, intervalMs);
  },
  async checkForUpdate() {
    try {
      const response = await fetch(`/version.json?cb=${Date.now()}`, {
        cache: "no-store",
      });

      if (!response.ok) {
        return;
      }

      const data = await response.json();
      const latestVersion =
        data.id || data.buildTime || data.version || data.build;
      if (!latestVersion) {
        return;
      }

      if (!store.currentVersion) {
        store.setCurrentVersion(latestVersion);
        return;
      }

      if (latestVersion !== store.currentVersion) {
        store.setHasNewVersion(true);

        if (this.toast) {
          this.toast.add({
            severity: "info",
            summary: "Update available",
            detail: "A new version is available. Please refresh.",
            life: 10000,
          });
        }

        if (pollTimer) {
          clearInterval(pollTimer);
          pollTimer = null;
        }
      }
    } catch (_error) {
      // Ignore network errors for version check
    }
  },
};
